(function () {
  angular.module("akitabox.building", [
    "ui.router",
    "akitabox.constants",
    "akitabox.core.constants",
    "akitabox.core.router",
    "akitabox.core.services.building",
    "akitabox.core.services.floor",
    "akitabox.core.services.pinType",
    "akitabox.core.toast",
    "akitabox.building.list",
    "akitabox.building.detail",
    "angular-cache",
  ]);
})();
